import React, { useRef, useState } from 'react'
import "./portfolio.scss";
import { motion } from "framer-motion";
import Navbar from '../landing/header/Navbar';
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Headernew from '../landing/headernew/Headernew';
import emailjs from '@emailjs/browser';
import { Modal } from 'react-bootstrap';
import Workflows from '../landing/workflows/Workflows';
import ScheduleButton from '../landing/main-banner/ScheduleButton';
const Portfolio = () => {
    const cardVariants = {
        hidden: { opacity: 0, y: 40 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: "easeOut" },
        },
    };
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const formRef = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        const templateParams = {
            name: `${firstName} ${lastName}`,
            time: new Date().toLocaleString(),
            email,
            message
        };

        emailjs.send(
            'service_1jfnbjv',
            'template_27g17wh',
            templateParams,
            '0bsaQ34kM5y5nImAo'
        ).then(
            (result) => {
                // alert("Message sent successfully!");
                handleShow();
                setFirstName('');
                setLastName('');
                setEmail('');
                setMessage('');
            },
            (error) => {
                alert("Failed to send message. Please try again.");
                console.error(error.text);
            }
        );
    };
    const cardsData = [
        {
            title: "Save time & reduce errors",
            desc: "Automate repetitive tasks to free up your team for higher-value work",
            img: "/assets/paone.svg",
        },
        {
            title: "Enhance collaboration",
            desc: "Streamline processes between departments and teams",
            img: "/assets/patwo.svg",
        },
        {
            title: "Strengthen compliance",
            desc: "Built-in audit trails and security for regulatory requirements",
            img: "/assets/pathree.svg",
        },
        {
            title: "Increase productivity",
            desc: "Automated workflows that work 24/7 without fatigue",
            img: "/assets/paone.svg",
        },
        {
            title: "Boost morale",
            desc: "Free your team from tedious manual tasks",
            img: "/assets/patwo.svg",
        },
        {
            title: "Real ROI",
            desc: "Measurable results with tangible cost savings",
            img: "/assets/pathree.svg",
        },
    ];
    const stats = [
        { number: "70+", label: "Automation Solutions" },
        { number: "100+", label: "Satisfied Clients" },
        { number: "70%", label: "Time Saved" },
        { number: "90%", label: "Error Reduction" },
    ];
    const testimonialVariant = {
        hidden: { opacity: 0, y: 40 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: { delay: i * 0.2, duration: 0.5 },
        }),
    };
    const testimonials = [
        {
            quote:
                "TechSecure360 automated our HR onboarding process, reducing manual work by 80%. The Power Automate solution they implemented has transformed how we handle new hires.",
            name: "Sarah Johnson",
            role: "HR Director, TechCorp Inc.",
        },
        {
            quote:
                "The document management automation has saved our team 15 hours per week. We now have all contracts organized in SharePoint with automated renewal reminders.",
            name: "Michael Chen",
            role: "Operations Manager, Global Solutions",
        },
        {
            quote:
                "Our approval processes used to take days, now they're completed in hours. The multi-level approval workflow has dramatically improved our efficiency.",
            name: "Emily Rodriguez",
            role: "Finance Controller, Innovate Ltd.",
        },
    ];


    return (
        <>
            <div id="portfolio">
                <section className="main-banner security_main" >
                    <Headernew />
                    <video
                        className="main-banner-video"
                        muted
                        playsInline
                        autoPlay
                        loop
                        width="100%"
                        id="myVideo"
                    >
                        <source src="/assets/bannervideo.mp4" type="video/mp4" />
                    </video>

                    <div className="custom-container1">
                        <div className="top_banner">
                            <motion.h3
                                initial={{ x: -100, opacity: 0 }}
                                whileInView={{ x: 0, opacity: 1 }}
                                viewport={{ once: false }} 
                                transition={{ duration: 1 }}
                            >
                                Transform Your Business with Power Automate


                            </motion.h3>
                            <motion.p
                                initial={{ x: -100, opacity: 0 }}
                                whileInView={{ x: 0, opacity: 1 }}
                                viewport={{ once: false }} 
                                transition={{ duration: 1 }}
                            >
                                <p className='paragraphtexttt'>70+ real-world automation solutions that save time, reduce errors, and boost productivity</p>

                            </motion.p>


                        </div>
                    </div>
                </section>
                <section className='about_detail'>
                    <motion.div
                        className='inner_about_Sec'
                        initial={{ opacity: 0, y: 60 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: false, amount: 0.2 }}
                    >
                        <motion.h2
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6 }}
                            viewport={{ once: false, amount: 0.2 }}
                        >
                            About TechSecure360
                        </motion.h2>

                        <motion.h3
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.1 }}
                            viewport={{ once: false, amount: 0.2 }}
                        >
                            Empowering businesses through intelligent automation
                        </motion.h3>

                        <motion.p
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.2 }}
                            viewport={{ once: false, amount: 0.2 }}
                        >
                            At TechSecure360, we've helped 100+ satisfied clients across industries optimize processes through automation—solving real-world challenges in areas like approvals, document control, communication, and data workflows.
                        </motion.p>

                        <motion.p
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.3 }}
                            viewport={{ once: false, amount: 0.2 }}
                        >
                            Each solution we create reflects our commitment to delivering scalable, secure, and intelligent automation using the Microsoft Power Platform and SharePoint ecosystem.


                        </motion.p>

                   
                        <div className='cards_abouts'>
                            {[
                                {
                                    icon: "🔄",
                                    title: "End-to-End Solutions",
                                    desc: "We don't just automate workflows—we design, implement, and manage full SharePoint environments.",
                                },
                                {
                                    icon: "🏢",
                                    title: "Industry Experience",
                                    desc: "Proven solutions across finance, healthcare, manufacturing, and technology sectors.",
                                },
                                {
                                    icon: "🔒",
                                    title: "Security Focused",
                                    desc: "All solutions built with enterprise-grade security and compliance standards.",
                                },
                                {
                                    icon: "⚙️",
                                    title: "Full Implementation",
                                    desc: "From intranet setup to role-based access and security configuration.",
                                },
                            ].map((card, index) => (
                                <motion.div
                                    className='end_cards'
                                    key={index}
                                    initial={{ opacity: 0, y: 50 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5, delay: index * 0.2 }}
                                    viewport={{ once: false, amount: 0.2 }}
                                >
                                    <h3>{card.icon}</h3>
                                    <h4>{card.title}</h4>
                                    <p>{card.desc}</p>
                                </motion.div>
                            ))}
                        </div>
                    </motion.div>

                 
                    <motion.div
                        className="our_experties"
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7 }}
                        viewport={{ once: false, amount: 0.2 }}
                    >
                        <h3>Our Expertise</h3>
                        <div className="expert_cards">
                            {[
                                "SharePoint Specialists",
                                "Power Automate Experts",
                                "IT Management",
                                "Infosec Compliance",
                                "App Security",
                                "Process Automation",
                            ].map((expert, i) => (
                                <motion.h4
                                    key={i}
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ delay: i * 0.15, duration: 0.4 }}
                                    viewport={{ once: false, amount: 0.2 }}
                                >
                                    {expert}
                                </motion.h4>
                            ))}
                        </div>
                    </motion.div>
                </section>
                <section className='secure_main1'>
                    <img src='/assets/elipses.png' className='elipses' alt='background design' />
                    <div className='custom-container1'>
                        <div className='inner_secure'>
                            <h3>Why Choose Our Automation Solutions?

                            </h3>
                            <div className='parent_four_cards newone'>
                                {cardsData.map((card, index) => (
                                    <motion.div
                                        className='onne_card'
                                        key={index}
                                        custom={index}
                                        variants={cardVariants}
                                        initial='hidden'
                                        whileInView='visible'
                                        viewport={{ once: false, amount: 0.3 }} 
                                    >
                                        <div>
                                            <h4>{card.title}</h4>
                                            <p>{card.desc}</p>
                                        </div>
                                        <img src={card.img} alt={card.title} />
                                    </motion.div>
                                ))}
                            </div>


                        </div>
                    </div>

                </section>
                <section className="addanother_cards">
                    <div className="top_num">
                        {stats.map((item, i) => (
                            <motion.div
                                className="num_cardss"
                                key={i}
                                initial={{ opacity: 0, y: 40, scale: 0.95 }}
                                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                                transition={{ duration: 0.5, delay: i * 0.2 }}
                                viewport={{ once: false, amount: 0.3 }}
                                whileHover={{ y: -5, boxShadow: "0 10px 25px rgba(0,0,0,0.15)" }}
                                style={{
                                    borderRadius: "12px",
                                    transition: "box-shadow 0.3s ease, transform 0.3s ease",
                                    background: "#fff",
                                    padding: "20px",
                                }}
                            >
                                <h3>{item.number}</h3>
                                <h4>{item.label}</h4>
                            </motion.div>
                        ))}
                    </div>
                </section>

                <section className="automate_solution">
                    <div className="power_Siiiide">
                        <h2>Our Power Automate Solutions</h2>
                        <p>Comprehensive automation solutions for every business need</p>
                        <div className="parent_new_side">
                            <div className="side__topp">
                                <h5>🔄</h5>
                                <h3>Approval & Request Automation</h3>
                                <p>Multi-tier approvals for HR, Procurement, CapEx/OpEx, and IT requests</p>
                            </div>

                            <div className="parent_Flow">
                                <div className="flow_card">
                                    <h4>⏰</h4>
                                    <h5>Due Date Reminder Flow</h5>
                                    <h6>Monitor and manage tax-related due dates with automated reminders</h6>               <h6>Sends reminders 5, 10, or 20 days before due dates</h6>
                                    <h6>Uses SharePoint for tracking and storage</h6>
                                    <button>Reduces missed deadlines</button>
                                </div>
                                <div className="flow_card">
                                    <h4>✈️</h4>
                                    <h5>Travel with Laptop Approval</h5>
                                    <h6>Manage travel requests involving company laptops</h6>
                                    <h6>Approval by Group Leader or Project Manager</h6>
                                    <h6>Logs responses and comments in SharePoint</h6>
                                    <button>Improves decision turnaround
                                    </button>
                                </div>
                                <div className="flow_card">
                                    <h4>✔️</h4>
                                    <h5>Potential Client Approval</h5>
                                    <h6>Streamline approval process for potential client submissions</h6>
                                    <h6>Structured decision points with notifications</h6>
                                    <h6>Generates approval summaries for tracking</h6>
                                    <button>Ensures thorough reviews</button>
                                </div>
                                <div className="flow_card">
                                    <h4>🛒</h4>
                                    <h5>Purchase Form Approval</h5>
                                    <h6>Automate approval process for purchase requests</h6>
                                    <h6>Approvals based on purchase amounts
                                    </h6>
                                    <h6>Generates and saves approval PDFs</h6>
                                    <button>Reduces missed deadlines</button>
                                </div>
                                <div className="flow_card">
                                    <h4>📝</h4>
                                    <h5>Time Off Request Automation</h5>
                                    <h6>Simplify time-off requests and approvals</h6>
                                    <h6>Sends requests to line manager for approval</h6>
                                    <h6>Records approved time-off in Microsoft Shifts</h6>
                                    <button>Reduces administrative workload
                                    </button>
                                </div>
                                <div className="flow_card">
                                    <h4>📑</h4>
                                    <h5>Supplier Request Flow</h5>
                                    <h6>Streamline supplier onboarding process</h6>
                                    <h6>Collects supplier information and documents
                                    </h6>
                                    <h6>Notifies stakeholders and assigns request IDs</h6>
                                    <button>Enhances efficiency
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="parent_new_side">
                            <div className="side__topp">
                                <h5>📁</h5>
                                <h3>Document & File Management</h3>
                                <p>Auto-creation, classification, versioning, and secure archiving in SharePoint

                                </p>
                            </div>

                            <div className="parent_Flow">
                                <div className="flow_card">
                                    <h4>📂</h4>
                                    <h5>SharePoint Smart File Organizer</h5>
                                    <h6>Automatically organize files in SharePoint folders
                                    </h6>
                                    <h6>Moves files based on naming conventions
                                    </h6>
                                    <h6>Sends completion notifications
                                    </h6>
                                    <button>Reduces manual effort
                                    </button>
                                </div>
                                <div className="flow_card">
                                    <h4>📄
                                    </h4>
                                    <h5>Automated SharePoint Folder Creation</h5>
                                    <h6>Automate folder structure creation in SharePoint</h6>
                                    <h6>Creates predefined subfolders</h6>
                                    <h6>Copies template files automatically</h6>
                                    <button>Ensures consistency

                                    </button>
                                </div>
                                <div className="flow_card">
                                    <h4>📄</h4>
                                    <h5>Contract Management Flows</h5>
                                    <h6>Streamline contract submission and tracking</h6>
                                    <h6>Submits contracts via forms to SharePoint</h6>
                                    <h6>Sends expiration reminders</h6>
                                    <button>Reduces missed renewals</button>
                                </div>
                                <div className="flow_card">
                                    <h4>📄</h4>
                                    <h5>Daily Progress & Group Notes</h5>
                                    <h6>Capture form responses and save systematically</h6>
                                    <h6>Converts responses into PDF format
                                    </h6>
                                    <h6>Saves documentation to OneDrive</h6>
                                    <button>Ensures systematic tracking</button>
                                </div>
                                <div className="flow_card">
                                    <h4>📂</h4>
                                    <h5>Event File Organizer</h5>
                                    <h6>Organize uploaded files into structured folders</h6>
                                    <h6>Categorizes events by client and date</h6>
                                    <h6>Auto-creates folders: Fonts, PDFs, Sources</h6>
                                    <button>Reduces file misplacement
                                    </button>
                                </div>
                                <div className="flow_card">
                                    <h4>📄</h4>
                                    <h5>Document Management Automation</h5>
                                    <h6>Automates document submission and approval

                                    </h6>
                                    <h6>Microsoft Forms-driven input
                                    </h6>
                                    <h6>Conditional approval routing</h6>
                                    <button>Reduces handling time
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="parent_new_side">
                            <div className="side__topp">
                                <h5>📧</h5>
                                <h3>Email & Communication Automation
                                </h3>
                                <p>Intelligent email parsing, templated replies, and triggered notifications

                                </p>
                            </div>

                            <div className="parent_Flow">
                                <div className="flow_card">
                                    <h4>📧</h4>
                                    <h5>Automated Email Follow-Up</h5>
                                    <h6>Ensure timely follow-ups on email communications
                                    </h6>
                                    <h6>Tracks replies and sends reminders
                                    </h6>
                                    <h6>Automates follow-up reminders
                                    </h6>
                                    <button>Improves responsiveness
                                    </button>
                                </div>
                                <div className="flow_card">
                                    <h4>📧
                                    </h4>
                                    <h5>Consolidated Company Billing</h5>
                                    <h6>Generate consolidated billing emails for companies</h6>
                                    <h6>Lists relevant billings in a single email</h6>
                                    <h6>Sends to default address if contact missing</h6>
                                    <button>Reduces tracking errors

                                    </button>
                                </div>
                                <div className="flow_card">
                                    <h4>📧</h4>
                                    <h5>Email Based on Activation Date</h5>
                                    <h6>Send personalized emails based on service activation

                                    </h6>
                                    <h6>Welcome emails for new activations</h6>
                                    <h6>Due balance reminders for older accounts</h6>
                                    <button>Improves client satisfaction</button>
                                </div>
                                <div className="flow_card">
                                    <h4>📧</h4>
                                    <h5>Email Tracker with Follow-up Counter</h5>
                                    <h6>Automate intake and follow-up of important emails</h6>
                                    <h6>Logs attachments and metadata in SharePoint
                                    </h6>
                                    <h6>Tracks follow-up count and date</h6>
                                    <button>Minimizes missed communication</button>
                                </div>
                                <div className="flow_card">
                                    <h4>📢</h4>
                                    <h5>Event Notification Flow</h5>
                                    <h6>Automate notifications for new calendar events</h6>
                                    <h6>Sends email and SMS notifications</h6>
                                    <h6>Uses Office 365 and Twilio integration</h6>
                                    <button>Improves coordination
                                    </button>
                                </div>
                                <div className="flow_card">
                                    <h4>📧</h4>
                                    <h5>Multi-Level Email Approval + PDF</h5>
                                    <h6>Manages invoice approval workflows triggered by email

                                    </h6>
                                    <h6>Email-based multi-stage approval
                                    </h6>
                                    <h6>Approval trail HTML-to-PDF conversion</h6>
                                    <button>Speeds up invoice approval
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="parent_new_side">
                            <div className="side__topp">
                                <h5>📊</h5>
                                <h3>Data Collection, Processing & Reporting
                                </h3>
                                <p>Real-time intake via Microsoft Forms, synced to SharePoint/Excel



                                </p>
                            </div>

                            <div className="parent_Flow">
                                <div className="flow_card">
                                    <h4>📊</h4>
                                    <h5>Child Adolescent Survey Flow</h5>
                                    <h6>Automate survey processing and reporting
                                    </h6>
                                    <h6>Generates PDF reports from responses
                                    </h6>
                                    <h6>Updates data in Excel for analysis
                                    </h6>
                                    <button>Improves reporting efficiency
                                    </button>
                                </div>
                                <div className="flow_card">
                                    <h4>📊
                                    </h4>
                                    <h5>CSV Parsing and SharePoint Update</h5>
                                    <h6>Automate parsing and updates of CSV files</h6>
                                    <h6>Changes date formats and adds columns</h6>
                                    <h6>Updates processed files in SharePoint</h6>
                                    <button>Minimizes manual errors

                                    </button>
                                </div>
                                <div className="flow_card">
                                    <h4>📄</h4>
                                    <h5>Quiz Results Extraction</h5>
                                    <h6>Automate extraction and processing of quiz results

                                    </h6>
                                    <h6>Parses incoming emails for quiz details</h6>
                                    <h6>Updates Excel file with quiz data</h6>
                                    <button>Eliminates manual errors</button>
                                </div>
                                <div className="flow_card">
                                    <h4>📊</h4>
                                    <h5>Engineering Task Assignment Tracker</h5>
                                    <h6>Automates project assignments and feedback</h6>
                                    <h6>Priority scoring based on complexity
                                    </h6>
                                    <h6>Time-based reminders and escalation</h6>
                                    <button>Reduces missed deadlines</button>
                                </div>
                                <div className="flow_card">
                                    <h4>📊</h4>
                                    <h5>SharePoint Timesheet Approval</h5>
                                    <h6>Automates timesheet approvals and reporting</h6>
                                    <h6>Approves/rejects timesheet entries</h6>
                                    <h6>Generates detailed PDF reports</h6>
                                    <button>Reduces HR workload
                                    </button>
                                </div>
                                <div className="flow_card">
                                    <h4>📈</h4>
                                    <h5>Automate Sales System
                                    </h5>
                                    <h6>Streamline sales processes using structured data

                                    </h6>
                                    <h6>Automates outreach and follow-ups
                                    </h6>
                                    <h6>Flags prospects for manual calls</h6>
                                    <button>Increases response success
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="parent_new_side">
                            <div className="side__topp">
                                <h5>⚙️</h5>
                                <h3>Operations & Utility Flows
                                </h3>
                                <p>Utility automations for project assignments, document merging, and reminders



                                </p>
                            </div>

                            <div className="parent_Flow">
                                <div className="flow_card">
                                    <h4>📅</h4>
                                    <h5>Update Planner from Excel</h5>
                                    <h6>Automate task management with Planner and Excel
                                    </h6>
                                    <h6>Schedules task creation in Planner
                                    </h6>
                                    <h6>Updates tasks for user assignments
                                    </h6>
                                    <button>Simplifies task management
                                    </button>
                                </div>
                                <div className="flow_card">
                                    <h4>📅
                                    </h4>
                                    <h5>Weekly Work Plan Reminder</h5>
                                    <h6>Automate monitoring and updating of weekly work plans</h6>
                                    <h6>Checks statuses and sends reminders</h6>
                                    <h6>Creates new records for upcoming week</h6>
                                    <button>Enhances accountability

                                    </button>
                                </div>
                                <div className="flow_card">
                                    <h4>📎</h4>
                                    <h5>Merge PowerPoint via MS Forms</h5>
                                    <h6>Select and merge multiple PowerPoint files via Forms

                                    </h6>
                                    <h6>Form-driven file selection</h6>
                                    <h6>PowerPoint merge via Encodian</h6>
                                    <button>Saves time with automation</button>
                                </div>
                                <div className="flow_card">
                                    <h4>🖼️</h4>
                                    <h5>Form-to-PDF with Image Capture</h5>
                                    <h6>Generates structured PDFs from Forms with images

                                    </h6>
                                    <h6>Handles image attachments
                                    </h6>
                                    <h6>Base64 conversion and HTML embedding</h6>
                                    <button>Reduces manual formatting</button>
                                </div>
                                <div className="flow_card">
                                    <h4>🔄</h4>
                                    <h5>Recurring Task Management</h5>
                                    <h6>Streamline recurring task management in Planner</h6>
                                    <h6>Runs weekly to check and create tasks</h6>
                                    <h6>Updates tasks based on specific criteria</h6>
                                    <button>Reduces manual effort
                                    </button>
                                </div>
                                <div className="flow_card">
                                    <h4>🔢</h4>
                                    <h5>Project Code Generation
                                    </h5>
                                    <h6>Assign unique project codes based on form data

                                    </h6>
                                    <h6>Implements sequential numbering rules
                                    </h6>
                                    <h6>Tracks project codes in SharePoint</h6>
                                    <button>Simplifies tracking
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="clientdatttta">
                    <motion.div
                        className="succes_Store"
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7 }}
                        viewport={{ once: false, amount: 0.2 }}
                    >
                        <h2>What Our Clients Say</h2>
                        <p>Success stories from businesses we've automated</p>

                        <div className="porfolioo_cards">
                            {testimonials.map((t, i) => (
                                <motion.div
                                    key={i}
                                    className="port_cards"
                                    variants={testimonialVariant}
                                    initial="hidden"
                                    whileInView="visible"
                                    custom={i}
                                    viewport={{ once: false, amount: 0.2 }}
                                    whileHover={{
                                        y: -5,
                                        boxShadow: "0 10px 25px rgba(0,0,0,0.12)",
                                    }}
                                    style={{
                                        background: "#fff",
                                        padding: "20px",
                                        borderRadius: "12px",
                                        transition: "all 0.3s ease",
                                    }}
                                >
                                    <p>"{t.quote}"</p>
                                    <h3>{t.name}</h3>
                                    <h4>{t.role}</h4>
                                </motion.div>
                            ))}
                        </div>
                    </motion.div>
                </section>
                <section className='work_main'>
                    <motion.img
                        src='/assets/shade.png'
                        className='imggshade'
                        initial={{ opacity: 0, scale: 0.95 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 1 }}
                        viewport={{ once: false }}
                        alt='background shade'
                    />
                    <motion.video
                        className='main-banner-video'
                        muted
                        playsInline
                        autoPlay
                        loop
                        width="100%"
                        id="myVideo"
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        transition={{ duration: 1.2 }}
                        viewport={{ once: false }}
                    >
                        <source src="/assets/bottomvideo.mp4" type="video/mp4" />
                    </motion.video>

                    <div className='custom-container1'>
                        <motion.div
                            className='inner_work'
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8 }}
                            viewport={{ once: false }}
                        >
                            <h2>Ready to Modernize Your Workflows?</h2>

                            <motion.p
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.2, duration: 0.6 }}
                                viewport={{ once: false }}
                            >
                                Let’s talk about how we can secure and streamline your operations.
                            </motion.p>

                            <motion.div
                                className='buttons_div'
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.4, duration: 0.6 }}
                                viewport={{ once: false }}
                            >
                                <ScheduleButton />
                            </motion.div>
                        </motion.div>
                    </div>
                </section>
            </div>




        </>
    )
}

export default Portfolio
